import { render } from "./ProfileChangePassword.vue?vue&type=template&id=26303c39"
import script from "./ProfileChangePassword.vue?vue&type=script&lang=js"
export * from "./ProfileChangePassword.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__